import { createAction } from 'redux-actions';
export var restrictLoggedOut = createAction('@@loggedOut/RESTRICT_ACCESS', function () { return ({}); });
export var verifyLoggedOutAccess = createAction('@@loggedOut/VERIFY_ACCESS', function (action) { return ({ action: action }); });
//# sourceMappingURL=actionCreators.js.map